/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { UpdateTransactionUpperLimitForTheUserAccount200ResponseAvailableMerchantCategoriesInner } from './update-transaction-upper-limit-for-the-user-account200-response-available-merchant-categories-inner';
// May contain unused imports in some cases
// @ts-ignore
import { UpdateTransactionUpperLimitForTheUserAccount200ResponseReissue } from './update-transaction-upper-limit-for-the-user-account200-response-reissue';
// May contain unused imports in some cases
// @ts-ignore
import { UpdateTransactionUpperLimitForTheUserAccount200ResponseUser } from './update-transaction-upper-limit-for-the-user-account200-response-user';
// May contain unused imports in some cases
// @ts-ignore
import { UpdateTransactionUpperLimitForTheUserAccount200ResponseUserAccountGroup } from './update-transaction-upper-limit-for-the-user-account200-response-user-account-group';

/**
 * 
 * @export
 * @interface UpdateTransactionUpperLimitForTheUserAccount200Response
 */
export interface UpdateTransactionUpperLimitForTheUserAccount200Response {
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'isFraudLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'availableCurrencies': Array<UpdateTransactionUpperLimitForTheUserAccount200ResponseAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<UpdateTransactionUpperLimitForTheUserAccount200ResponseAvailableMerchantCategoriesInner>}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'availableMerchantCategories': Array<UpdateTransactionUpperLimitForTheUserAccount200ResponseAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {UpdateTransactionUpperLimitForTheUserAccount200ResponseUser}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'user': UpdateTransactionUpperLimitForTheUserAccount200ResponseUser;
    /**
     * 
     * @type {UpdateTransactionUpperLimitForTheUserAccount200ResponseUserAccountGroup}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'userAccountGroup'?: UpdateTransactionUpperLimitForTheUserAccount200ResponseUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     * @deprecated
     */
    'expiredDate': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     * @deprecated
     */
    'isRenewalProcessing': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     * @deprecated
     */
    'isAutoRenewalOnExpiration': boolean;
    /**
     * 
     * @type {UpdateTransactionUpperLimitForTheUserAccount200ResponseReissue}
     * @memberof UpdateTransactionUpperLimitForTheUserAccount200Response
     */
    'reissue'?: UpdateTransactionUpperLimitForTheUserAccount200ResponseReissue | null;
}

export const UpdateTransactionUpperLimitForTheUserAccount200ResponseAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type UpdateTransactionUpperLimitForTheUserAccount200ResponseAvailableCurrenciesEnum = typeof UpdateTransactionUpperLimitForTheUserAccount200ResponseAvailableCurrenciesEnum[keyof typeof UpdateTransactionUpperLimitForTheUserAccount200ResponseAvailableCurrenciesEnum];


